import React from "react";
//#region types
import { ChoiceChipsProps } from "models/propTypes/selectionPropTypes";
//#endregion
//#region components
import { Chip, Grid } from "@mui/material";
import GridR from "../grid/responsiveGrid";
import ChoiceChipsSkeleton from "../skeletons/choiceChipsSkeleton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ChoiceChips: React.FC<ChoiceChipsProps> = (props) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const key = e.currentTarget.getAttribute("data-key");

    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
    const item = props.items.find((item) => item.id == key);
    if (item) props.onChange(item);
  };

  return (
    <React.Fragment>
      {!props.isReadOnly ? (
        <Grid
          item
          container
          className={clsx(
            props.className,
            cssExports.selectionChipsGroup,
            cssExports.choiceChipsGroup,
            props.hasError && cssExports.errorChips
          )}
          data-testid="choiceChipsGroup"
        >
          <GridR item container className={cssExports.selectionChips} spacing={1} direction="row">
            {props.isLoading ? (
              <ChoiceChipsSkeleton />
            ) : props.items ? (
              props.items.map((item) => (
                <Grid item key={item.id} className={cssExports.chipContainer}>
                  <Chip
                    className={clsx(
                      cssExports.chip,
                      // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
                      props.value && item.id == props.value.id ? cssExports.selected : ""
                    )}
                    variant="outlined"
                    data-key={item.id}
                    label={item.value}
                    clickable
                    onClick={handleClick}
                    disabled={props.disabled || props.disabledItems?.some((di) => di === item.id)}
                    data-testid={`${item.id}-choiceChip`}
                  />
                </Grid>
              ))
            ) : (
              ""
            )}
          </GridR>
        </Grid>
      ) : (
        (props.value?.value ?? "")
      )}
    </React.Fragment>
  );
};

export default ChoiceChips;
